import React, { useContext } from 'react';

import { FilterButton } from '../../FilterButton';
import ClearFilterButton from '../ClearFilterButton';
import DiscoveryContextV2 from '../../../../../contexts/discoveryContext/contextV2';

import { bold } from './styles.module.css';

const SportValueComponent = ({ modalOpen, clearFilter, ...props }) => {
  const {
    filters: {
      sport: { id, label },
    },
  } = useContext(DiscoveryContextV2);

  const spanLabel = label ?? 'Sport';
  const hasSport = id !== -1;

  return (
    <FilterButton active={hasSport || modalOpen} {...props}>
      <span className={hasSport ? bold : undefined}>{spanLabel}</span>
      {hasSport && <ClearFilterButton onClick={clearFilter} />}
    </FilterButton>
  );
};

export default SportValueComponent;
